import React,{Component} from "react";
import appinfo from "../../clientsJSON";
import "./index.css";

class Media extends Component{
    render(){
        return(
            <div style={{marginLeft:"auto",marginRight:"auto", paddingBottom: "40px"}}>
                <h1 style={{textAlign:"center",color:appinfo.primaryTextColor}}>{appinfo.media.title}</h1>
               <div className="MediaArea">
                   <div className="mediavalue">
                     {appinfo.media.description.map(i=>{return(
                         <div>
                        <div className="media-team">
                           <img  src={i.image_url}/>
                          
                           <div className="media-text">
                              <a href={i.link} style={{textDecoration:"none"}}><p style={{colro:"#fff",height:"50px"}}>{i.short_description}</p></a>
                           </div>
                           
                       </div>
                       <a href={i.link} style={{textDecoration:"none"}}><h3 style={{margin:0, textDecoration: "none",textAlign:"center"}}>{i.title || ""}</h3></a>
                       </div>)})}
                      </div>
                      </div>
                      <p style={{textAlign:"center"}}>
                                           <a href={"/media"}  style={{textDecoration:"none",color:appinfo.secondary_Color}}>
                                            <button style={{color:appinfo.secondary_Color,border:"none",backgroundColor:appinfo.button_color,borderRadius:0,margin:10}}className="button" >VIEW ALL {appinfo.media.title}
                                            <i class="material-icons" style={{verticalAlign:"sub",height:16,fontSize:"large"}}>arrow_forward</i>
                                            </button>
                                          </a>
                                        </p>
               {/* <div className="MediaButton" style={{marginLeft:"auto",marginRight:"auto",margin:"40%",marginTop:10,marginBottom:0}}>
                <a href="/media"> <button style={{backgroundColor:"#002756",color:"#fff",border:"none"}}>View All Media</button></a>
               </div> */}
            </div>
            
        )
    }
}
export default Media